import React from 'react';
import AddSection from './addSection/AddSection';

type AddImportantPatientInformationSectionProps = {
  open: boolean;
  onClose: () => void;
  onAddSection: (
    name: string,
    options?: { position?: 'top'; sectionText?: string; medName?: string },
  ) => void;
};

const AddImportantPatientInformationSection = ({
  open,
  onClose,
  onAddSection,
}: AddImportantPatientInformationSectionProps) => {
  return (
    <AddSection
      open={open}
      onClose={onClose}
      onAddSection={onAddSection}
      options={[]}
      mode="importantPatientInformation"
    />
  );
};

export default AddImportantPatientInformationSection;
